<template>
  <range
    :label="$t('edit.sidebar.width')"
    min="100"
    max="500"
    step="1"
    :value="value()"
    :change="onChange"
    :move="onMove"
  ></range>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Range from '../../../../general/Range.vue';

const defaultValue = 250;

export default {
  props: [
    'item',
    'general',
  ],
  components: {
    Range,
  },
  methods: {
    value() {
      const style = this.stepStyle(this.item);

      if (!style || !style.width) {
        return defaultValue;
      }

      return style.width.replace('px', '');
    },
    onChange(value) {
      if (this.general) {
        return this.quizUpdateStyle({
          item: this.item,
          rule: 'width',
          value: `${value}px`,
        });
      }

      return this.stepUpdateStyle({
        item: this.item,
        rule: 'width',
        value: `${value}px`,
      });
    },
    onMove(value) {
      if (this.general) {
        return this.quizPreviewStyleChange({
          item: this.item,
          rule: 'width',
          value: `${value}px`,
        });
      }

      return this.stepPreviewStyleChange({
        item: this.item,
        rule: 'width',
        value: `${value}px`,
      });
    },
    ...mapActions([
      'quizUpdateStyle',
      'quizPreviewStyleChange',
      'stepUpdateStyle',
      'stepPreviewStyleChange',
    ]),
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Width.vue?067f25a9
 **/